import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect, DispatchProp } from 'react-redux';

import { pushPostAuthenticationRequestPage } from '../../../../redux/actions/postAuthenticationRequests';
import { toggleLogInFormVisibility, toggleSignUpFormVisibility } from '../../../../redux/actions/ui';
import { createHref } from '../../../../utils/router';

import Button, { ButtonProps } from '../../../atoms/buttons/Button';
import LinkButton, { LinkButtonProps } from '../../../atoms/buttons/LinkButton';
import Badge from '../../../atoms/feedback/Badge';
import { IconCart, IconProject, LogoBopper } from '../../../atoms/images/Icon';
import DropdownMenu, { DropdownMenuOptions } from '../../../molecules/blocks/DropdownMenu';
import { BrowsePagePath } from '../../../pages/browse/Browse';
import { CartPagePath } from '../../../pages/Cart';
import { ProjectsPagePath } from '../../../pages/Projects';
import { AccountDropDownMenuOptions, HelpDropDownMenuOptions } from '../Header/DropdownMenus';

import { LoginPagePath, SignupPagePath } from '../../../pages/account/Login';
import { SearchBox } from '../SearchBox';
import UserProfile from './UserProfile';

// tslint:disable-next-line:no-empty-interface
interface IOwnState {
  activeDropdownMenu?: string;
}

interface IOwnStateProps {
  currentLocation: IRouterLocation;
  itemsInCart: number;
  isUserLoggedIn: boolean;
}

interface IOwnProps {
  cartInfo: GQL.ICart | null;
  userProfile: GQL.IProfile | null;
  type?: HeaderType;
}

interface IOwnMergedProps {
  showLogInForm(): void;
  showSignUpForm(): void;
}

const CartButton = (
  { className, label, activeClassName }: { className?: string; label: string | number, activeClassName?: string },
) => (
  <LinkButton to={CartPagePath} className={className} activeClassName={activeClassName}>
    <IconCart />
    <Badge label={`${label}`} variant="notification" />
  </LinkButton>
);

const classes = new BEM('app-nav');

const buttonProps: Partial<ButtonProps> = {
  size: 'large',
};

const linkButtonProps: Partial<LinkButtonProps> = {
  activeClassName: 'button--is-active',
  ...buttonProps,
};

class AppNavComponent extends React.Component<IOwnProps & IOwnStateProps & IOwnMergedProps, IOwnState> {
  constructor(props) {
    super(props);

    this.state = {
      activeDropdownMenu: '',
    };
  }

  render() {
    const {
      cartInfo,
      isUserLoggedIn,
      userProfile,
      type,
    } = this.props;

    const hasItemsInCart = cartInfo && cartInfo.license_line_items && cartInfo.license_line_items!.length;
    return (
      <div {...classes('', { [type!]: !!type })}>
        <LinkButton
          variant="icon"
          icon={<LogoBopper />}
          {...classes('logo')}
          size="small"
          includeQsParams
          to={BrowsePagePath}
        />

        <SearchBox size={type === 'extended' ? 'medium' : 'small'} />

        <nav {...classes('nav')}>
          <LinkButton to={BrowsePagePath} label="Browse&nbsp;Music" {...linkButtonProps} />
          {isUserLoggedIn ? (
            // tslint:disable-next-line:max-line-length
            <LinkButton to={ProjectsPagePath} iconPosition="right" icon={<IconProject/>} label="Saved" {...linkButtonProps} />
          ) : (
            <DropdownMenu
              Button={<Button iconPosition="right" icon={<IconProject/>} label="Saved" {...buttonProps} />}
              options={this.getLogInDropDownMenuOptions()}
              requestClose={this.state.activeDropdownMenu !== 'playlists'}
              disableOnClickOutside={this.state.activeDropdownMenu !== 'playlists'}
              onToggle={this.onToggleDropdownMenu('playlists')}
            />
          )}
          <DropdownMenu
            menu="help"
            Button={<Button label="Help" {...buttonProps} />}
            options={HelpDropDownMenuOptions}
            requestClose={this.state.activeDropdownMenu !== 'help'}
            disableOnClickOutside={this.state.activeDropdownMenu !== 'help'}
            onToggle={this.onToggleDropdownMenu('help')}
          />
          <CartButton
            label={hasItemsInCart ? cartInfo!.license_line_items!.length : '0'}
            {...classes('nav__cart')}
          />
          <DropdownMenu
            menu="account"
            // tslint:disable-next-line:max-line-length
            Button={(isUserLoggedIn && <Button label={<UserProfile profile={userProfile} />} {...buttonProps} />) || <></>}
            options={isUserLoggedIn ? AccountDropDownMenuOptions : this.getLogInDropDownMenuOptions()}
            requestClose={this.state.activeDropdownMenu !== 'account'}
            disableOnClickOutside={this.state.activeDropdownMenu !== 'account'}
            onToggle={this.onToggleDropdownMenu('account')}
            align="right"
            {...classes('account')}
          />
          {!isUserLoggedIn ? (
            <>
              <LinkButton to={LoginPagePath} label="Log In" {...linkButtonProps } />
              {/* tslint:disable-next-line:max-line-length */}
              <LinkButton
                to={SignupPagePath}
                colorScheme="dark"
                label="Create Account"
                {...linkButtonProps}
                {...classes('signup')}
                size="small"
              />
            </>
          ) : (<></>)}
        </nav>
      </div>
    );
  }

  onToggleDropdownMenu = (id: string) => (open: boolean) => {
    this.setState({ activeDropdownMenu: open ? id : undefined });
  }

  getLogInDropDownMenuOptions(): DropdownMenuOptions {
    return [(
      <Button
        key="login"
        label="Log In"
        onClick={this.props.showLogInForm}
        {...buttonProps}
      />), (
      <Button
        key="signup"
        label="Sign Up"
        onClick={this.props.showSignUpForm}
        {...buttonProps}
      />),
    ];
  }
}

// tslint:disable-next-line:max-line-length
const ConnectedAppNav = connect<IOwnStateProps, DispatchProp<any>, IOwnProps, IOwnStateProps & IOwnMergedProps, IStoreState>(
  ({ cart, found, user }, props) => ({
    itemsInCart: !!cart && cart.lineItems.length,
    currentLocation: found.match.location,
    isUserLoggedIn: user.isLoggedIn,
    ...props,
  }),
  (dispatch) => ({ dispatch }),
  (stateProps, { dispatch }) => ({
    ...stateProps,
    showLogInForm: () => {
      dispatch(pushPostAuthenticationRequestPage({ page: createHref(stateProps.currentLocation) }));
      dispatch(toggleLogInFormVisibility(true));
    },
    showSignUpForm: () => {
      dispatch(pushPostAuthenticationRequestPage({ page: createHref(stateProps.currentLocation) }));
      dispatch(toggleSignUpFormVisibility(true));
    },
  }),
)(AppNavComponent);

export const AppNavigation = ConnectedAppNav;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/AppNavigation/index.tsx